export default "__VITE_ASSET__BhHjsW43__"